import { ref, reactive, onMounted } from 'vue'

export function useVideoLoading() {
  const videoStates = reactive({
    hero: false,
    home: false,
    contact: false
  })
  
  const isLoading = ref(true)
  const totalVideos = 3 // Número total de vídeos para carregar
  const loadedVideos = ref(0)
  
  /**
   * Marca um vídeo como carregado
   * @param {string} videoKey - Chave do vídeo (hero, home, contact)
   */
  const markVideoLoaded = (videoKey) => {
    if (!videoStates[videoKey]) {
      videoStates[videoKey] = true
      loadedVideos.value++
      
      // Se todos os vídeos foram carregados, finalizar loading
      if (loadedVideos.value >= totalVideos) {
        setTimeout(() => {
          isLoading.value = false
          // Garantir que o scroll volte ao normal
          document.body.style.overflow = 'auto'
          document.body.classList.remove('loading-active')
        }, 500) // Pequeno delay para transição suave
      }
    }
  }
  
  /**
   * Verifica se todos os vídeos foram carregados
   * @returns {boolean}
   */
  const areAllVideosLoaded = () => {
    return loadedVideos.value >= totalVideos
  }
  
  /**
   * Reseta o estado de loading (útil para mudanças de rota)
   */
  const resetLoading = () => {
    Object.keys(videoStates).forEach(key => {
      videoStates[key] = false
    })
    loadedVideos.value = 0
    isLoading.value = true
  }
  
  /**
   * Força o fim do loading (fallback de segurança)
   */
  const forceFinishLoading = () => {
    setTimeout(() => {
      isLoading.value = false
      // Garantir que o scroll volte ao normal
      document.body.style.overflow = 'auto'
      document.body.classList.remove('loading-active')
    }, 3000) // Máximo 3 segundos de loading
  }
  
  return {
    videoStates,
    isLoading,
    loadedVideos,
    totalVideos,
    markVideoLoaded,
    areAllVideosLoaded,
    resetLoading,
    forceFinishLoading
  }
} 